import React from "react";
import optionCallback from "./optionCallback";

export default function Base({ svgProps, backgroundColor, children }) {
	return <svg xmlns="http://www.w3.org/2000/svg" {...svgProps} viewBox="0 0 1000 1000">
		<g>
			<rect width="1000" height="1000" fill={backgroundColor}/>
			{children}
		</g>
	</svg>
}